import type { TLocation, TLocationBody } from "@/models/location.model"
import { languageParser } from "./language.mapper"

export class LocationMapper {
  private static _mapSingleLocationToDto(item: TLocation | null | undefined): TLocation {
    // Validar que el ítem no sea nulo
    if (!item) {
      return {} as TLocation
    }

    try {
      return {
        id: item.id ?? "",
        code: item.code ?? "",
        description: languageParser(item.description) || { short: "", long: "" },
        order: typeof item.order === "number" ? item.order : 0,
        venue: typeof item.venue === "object" && item.venue !== null
          ? {
              id: item.venue.id ?? "",
              code: item.venue.code ?? "",
              description: languageParser(item.venue.description) || { short: "", long: "" },
              order: typeof item.venue.order === "number" ? item.venue.order : 0,
              mapUrl: item.venue.mapUrl ?? "",
            }
          : {
              id: "",
              code: "",
              description: { short: "", long: "" },
              order: 0,
              mapUrl: "",
            },
        discipline: Array.isArray(item.discipline)
          ? item.discipline.map(d => d ?? "")
          : [],
      }
    }
    catch (error) {
      console.error("Error al procesar ubicación:", error)
      return {} as TLocation
    }
  }

  // Overload signatures for strong typing
  static toDto(rawData: TLocation): TLocation
  static toDto(rawData: TLocation[]): TLocation[]
  // Implementation signature
  static toDto(rawData: TLocation | TLocation[] | null | undefined): TLocation | TLocation[] {
    if (Array.isArray(rawData)) {
      return rawData.map(item => LocationMapper._mapSingleLocationToDto(item))
    }
    else {
      // Handles a single Location object, or null/undefined if passed directly
      return LocationMapper._mapSingleLocationToDto(rawData)
    }
  }

  // Convierte TLocation a TLocationBody
  static toBody(location: TLocation): TLocationBody {
    return {
      code: location.code ?? "",
      description: location.description,
      order: typeof location.order === "number" ? location.order : 0,
      venueId:
        typeof location.venue === "string"
          ? location.venue
          : location.venue?.id ?? "",
      discipline: Array.isArray(location.discipline)
        ? location.discipline.map(d => d ?? "")
        : [],
    }
  }
}
